import { render, staticRenderFns } from "./DetailCustomerPoint.vue?vue&type=template&id=64791d8d&scoped=true&"
import script from "./DetailCustomerPoint.vue?vue&type=script&lang=js&"
export * from "./DetailCustomerPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64791d8d",
  null
  
)

export default component.exports